import { render, staticRenderFns } from "./ActivityLogTable.vue?vue&type=template&id=046d7476&scoped=true"
import script from "./ActivityLogTable.vue?vue&type=script&lang=ts"
export * from "./ActivityLogTable.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLogTable.vue?vue&type=style&index=0&id=046d7476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d7476",
  null
  
)

export default component.exports